import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.xdos.uk';

export type EventRuntimeResponse = {
  eventId: string;
  name: string;
  title?: string;
  gameType: string;
  phase?: 'pre' | 'during' | 'post';
  gamePeriod: number;
  maxGamePeriods: number;
  inPlay: boolean;
  periodStatus?: 'ready' | 'running' | 'ended';
  labels?: {
    currentPeriodName: string;
    nextPeriodName: string;
    startActionLabel: string;
    endActionLabel: string;
    gameOverLabel: string;
    continuous?: boolean;
  };
  score?: {
    left: number;
    right: number;
  };
  timer: {
    startedAt: number | null;
    accumulatedMs: number;
    running: boolean;
  };
  permissions: {
    canControlTimer: boolean;
    canViewTimer: boolean;
  };
  log: {
    ts: number;
    action: string;
    actorUserId?: string;
    actorRole?: string | null;
    note?: string;
  }[];
};

export async function getEventRuntime(eventId: string): Promise<EventRuntimeResponse> {
  const data = await axios.get<any, EventRuntimeResponse>(`${API_URL}/events/${eventId}/runtime`);

  console.log('[event-runtime.service] getEventRuntime data', data);

  return data;
}

export async function startEvent(eventId: string): Promise<EventRuntimeResponse> {
  const data = await axios.post<any, EventRuntimeResponse>(`${API_URL}/events/${eventId}/start`, {});

  console.log('[event-runtime.service] startEvent data', data);

  return data;
}

export async function endEvent(eventId: string): Promise<EventRuntimeResponse> {
  const data = await axios.post<any, EventRuntimeResponse>(`${API_URL}/events/${eventId}/end`, {});

  console.log('[event-runtime.service] endEvent data', data);

  return data;
}
export async function adjustScore(eventId: string, side: 'left' | 'right', delta: number): Promise<EventRuntimeResponse> {
  const data = await axios.post<any, EventRuntimeResponse>(`${API_URL}/events/${eventId}/score`, { side, delta });

  console.log('[event-runtime.service] adjustScore data', data);

  return data;
}